var Tracker = function( project ) {
	// project is unique for the specific project to be tracked
	this.project = project;
	this.tracked = {};
};


Tracker.prototype = {
	trackOnce: function( data ) {
	  if(!data || this.tracked[data]) {
	    return false;
	  }

	  this.tracked[data] = true;
	  this.trackMetric( data );

	},

	trackMetric: function(data) {
	  try {
	    window.trackMetrics({
	      type: 'user-interaction',
	      data: {
	        interaction: 'interactive: ' + this.project + ' : ' + data
	      }
	    });
	  } catch (e) {
	    // JSMD library is missing
	  }
	}
};




module.exports = Tracker;



// WEBPACK FOOTER //
// ./src/js/proj/tracker.js